<template>
  <div>
    <Modal
      :visible="visible"
      :keyboard="false"
      :closable="false"
      :centered="true"
      :width="1024"
      class="modal-cafe"
    >
      <template>
        <div id="cafe01" class="modal modal--widthLL">
          <div class="modal__inner">
            <div class="modal__content">
              <div class="p-order__modal-block">
                <h2 class="modal-header-text">カフェテリアポイント利用申請</h2>
              </div>

              <div v-if="isError" class="alert-top">
                {{ errMessage }}
              </div>

              <div class="p-order__modal-block p-order__modal-block--border">
                <h3 class="c-title2 mb-1">申請可能メニュー</h3>

                <aside class="textlevel-body4 mb-4">※複数ある場合は、申請するメニューを1つご選択ください。</aside>

                <div class="p-menu-seat-selection__list--seat-list__left radio d-block">
                  <div class="c-radio flex-column w-100 mb-3" v-for="(menu, index) in cafeInfo" :key="index">
                    <label class="c-radio__inner">
                      <input
                        ref="radio"
                        type="radio"
                        name="input-radio"
                        v-model="radioVal"
                        :value="menu.cafeMenuNo"
                        @change="changeCafeMenuInfo(menu)"
                      />
                      <div class="c-radio__box mb-auto"></div>
                      <div class="c-radio__label">
                        <p class="mb-1 pt-2">
                          メニューNo.
                          <span class="cafe-menu-no">{{ menu.cafeMenuNo }}</span><br>
                          <span class="cafe-menu-name">{{ menu.cafeMenuNm }}</span><br>
                          <span class="point-rate">ポイントレート:1pt={{ menu.pointRate }}円({{ generatePointRateLabel(menu.rounding) }})</span><br>
                          <span>{{ menu.applicationComment.commentJp }}</span>
                        </p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div class="p-order__modal-block p-order__modal-block--border">
                <h3 class="c-title2 mb-1">申請ポイント</h3>

                <div class="input-point-root mb-1">
                  <div :class="['c-spinner', 'd-inline-block', 'mr-3', { 'c-spinner__error': errorType !== 'NoError' }]">
                    <div class="c-spinner__inner">
                      <div class="c-spinner__button" @click="clickStepDown">
                        <icon name="action_circle_minus_fill" width="24" height="24" viewBox="0 0 24 24" colorClass="coolgray" />
                      </div>

                      <input
                        type="number"
                        min="0"
                        class="c-spinner__window"
                        v-model.number="usePoint"
                        @keypress="validateNumber($event)"
                        @change="changeSpinner" 
                      />

                      <div class="c-spinner__button" @click="clickStepUp">
                        <icon name="action_circle_plus_fill" width="24" height="24" viewBox="0 0 24 24" colorClass="coolgray" />
                      </div>
                    </div>
                  </div>

                  <div class="p-menu-seat-selection__list--seat-list__left radio d-inline-block">
                    <div class="c-radio" v-for="option in optionUsePoint" :key="option.value">
                      <label class="c-radio__inner">
                        <!-- ↓ 申請金額が選択できなくなったのでコメントアウト。将来必須。 -->
                        <!-- <input
                          ref="radio"
                          type="radio"
                          name="input-point_type"
                          :value="option.value"
                          v-model="usePointType"
                          @change="changeUsePointType"
                        />
                        <div class="c-radio__box"></div> -->
                        <!-- ↑ -->
                        <div class="c-radio__label">{{ option.label }}</div>
                      </label>
                    </div>
                  </div>
                  <div class="mypoint-root-available-point py-1" v-if="selectedCafeMenuInfo !== undefined">
                    <div class="pt-2">
                      <ul>
                        <li class="font-sml media-phone">
                          ※円をポイント換算する際の端数は切り捨てとなっております。
                        </li>
                        <li class="font-sml media-phone">
                          ※申請上限ポイントは、申込金額・残ポイント数・ポイント申請条件をもとに算出しております。
                        </li>
                      </ul>
                    </div>
                    <p>
                      <span class="cafe-available-label">申請上限ポイント</span>
                      <span class="textlevel-body1-bold">{{ selectedCafeMenuInfo.upperLimitPoint | formatInteger }}</span>
                      <span class="textlevel-body4">ポイント</span>
                    </p>
                    <div>
                      <ul>
                        <li class="font-sml media-pc">
                          ※円をポイント換算する際の端数は切り捨てとなっております。
                        </li>
                        <li class="font-sml media-pc">
                          ※申請上限ポイントは、申込金額・残ポイント数・ポイント申請条件をもとに算出しております。
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mypoint-root mb-2" v-if="selectedCafeMenuInfo !== undefined">
                  <p>
                    <span class="cafe-available-label">申請金額</span>
                    <span class="ml-1 textlevel-body1-bold">
                      <span v-if="usePointType == 'Point'">{{ generateRateForPoint(selectedCafeMenuInfo) | formatInteger }}</span>
                      <!-- ↓ 金額は一旦保留だが、将来必須なので残すが判定は常にfalse -->
                      <span v-if="usePointType == 'Cash'">{{ usePoint | formatInteger }}</span>
                      <!-- ↑ -->
                    </span>
                    <span class="textlevel-body4">円</span>
                    <span class="textlevel-body4">(1pt={{ selectedCafeMenuInfo.pointRate }}円)</span>
                  </p>
                </div>

                <div class="p-order-error__agree p-order-error__agree-margin text-left mb-4" v-if="errorType !== 'NoError'">
                  <icon name="alert" width="16" height="16" viewBox="0 0 20 20" colorClass="errored" />
                  <span v-if="errorType === 'Blank'">{{ getErrorBlank }}</span>
                  <span v-if="errorType === 'NotPositive'">{{ getErrorNotPositive }}</span>
                  <span v-if="errorType === 'NotNum'">{{ getErrorNum }}</span>
                  <span v-if="errorType === 'ExceedPoint'">{{ getErrorExceedPoint }}</span>
                  <span v-if="errorType === 'ExceedCash'">{{ getErrorExceedCash }}</span>
                </div>

                <div class="py-2">
                  <ul>
                    <li>
                      ＜ポイント申請にあたり＞
                    </li>
                    <li class="text-caution" v-if="showAgree1()">
                      ・ご本人の同行が必須となります。
                    </li>
                    <li>
                      ・利用対象者は以下となっております。
                    </li>
                    <li>
                      相違がないかご確認の上、チェックをして申請内容を確定してください。
                    </li>
                  </ul>
                </div>

                <div class="checkboxes pb-2">
                  <div class="c-checkbox d-block mb-2" v-if="showAgree1()">
                    <label class="c-checkbox__inner">
                      <input type="checkbox" v-model="checkedAgree1" />
                      <div class="c-checkbox__label text-caution">本人が同行します</div>
                    </label>
                  </div>
                  <div class="c-checkbox d-block mb-2" v-if="showAgree2()">
                    <label class="c-checkbox__inner">
                      <input type="checkbox" v-model="checkedAgree2" />
                      <div class="c-checkbox__label">利用者は本人です</div>
                    </label>
                  </div>
                  <div class="c-checkbox d-block mb-2" v-if="showAgree3()">
                    <label class="c-checkbox__inner">
                      <input type="checkbox" v-model="checkedAgree3" />
                      <div class="c-checkbox__label">利用するのは{{ selectedCafeMenuInfo.targetUsers.detail }}です</div>
                    </label>
                  </div>
                  <div class="c-checkbox d-block mb-2" v-if="showAgree4()">
                    <label class="c-checkbox__inner">
                      <input type="checkbox" v-model="checkedAgree4" />
                      <div class="c-checkbox__label">利用者は本人、{{ selectedCafeMenuInfo.targetUsers.detail }}です</div>
                    </label>
                  </div>
                </div>
              </div>

              <div class="p-order__modal-block mb-5">
                <h3 class="text-caution mb-1 c-title3">【申請の際の注意事項】</h3>
                <ul>
                  <li>
                    ※退職のご予定がある方は、団体様で定められている退職時の申請・利用期限をご確認の上、ご申請ください。
                    <ul class="ml-3">
                      <li>退職時の申請・利用期限を超えたご申請となっている場合、原則お取消となりますのでご注意ください。</li>
                    </ul>
                  </li>
                  <li>
                    ※差額のご入金が発生する場合は、年度末申請期日までにご入金いただく必要がございます。
                    <ul class="ml-3">
                      <li>年度末申請期日までにご入金が確認できない場合は、原則自動キャンセルとなります。</li>
                    </ul>
                  </li>
                  <li class="text-caution">
                    ※カフェテリアポイントはキャンセル料へは適用できません。
                    <ul class="ml-3">
                      <li>キャンセル料は、カフェテリアポイント適用前の料金から起算いたします。</li>
                    </ul>
                  </li>
                </ul>
              </div>

              <div class="p-order-subsidy-modal__button">
                <div class="c-buttonWrap2">
                  <button type="button" class="c-button c-button__primary c-button__primary--color4" @click="hideModal">キャンセル</button>
                </div>
                <div class="c-buttonWrap2">
                  <button
                    type="button"
                    :class="['c-button', 'c-button__primary', 'c-button__primary--color2', { 'c-button__primary--inactive': disabledSubmit() }]"
                    @click="clickSubmit()"
                  >
                    申請内容を確定する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import func_utils from '@/mixins/func_utils'
export default {
  mixins: [func_utils],
  data() {
    return {
      selectedCafeMenuInfo: {},
      // optionUsePoint: [
      //   { value: 'Point', label: 'ポイント' },
      //   { value: 'Cash', label: '円' }
      // ],
      optionUsePoint: [
        { value: 'Point', label: 'ポイント' }
      ],
      usePoint: 0,
      usePointType: "Point",
      errorType: "NoError",
      isError: false,
      errMessage: "",
      billAmount: 0,
      checkedAgree1: false,
      checkedAgree2: false,
      checkedAgree3: false,
      checkedAgree4: false,
      radioVal: ""
    };
  },
  props: {
    cafeInfo: {
      type: Array
    },
    totalPrice: {
      type: Number
    },
    visible: {
      type: Boolean
    },
    totalAdult: {
      type: Number
    },
    totalChildren: {
      type: Number
    },
    stayDays: {
      type: Number
    },
    useDate: {
      type: String
    },
    subsidyTotal: {
      type: Number
    }
  },
  methods: {
    setCafeData() {
      this.selectedCafeMenuInfo = this.cafeInfo[0];
      this.radioVal = this.selectedCafeMenuInfo ? this.selectedCafeMenuInfo.cafeMenuNo : '';
      console.log('this.radioVal', this.radioVal);
      this.usePointType = "Point";
      this.usePoint = 0;
      this.checkedAgree1 = false;
      this.checkedAgree2 = false;
      this.checkedAgree3 = false;
      this.checkedAgree4 = false;
    },
    changeCafeMenuInfo(newCafeMenuInfo) {
      this.selectedCafeMenuInfo = newCafeMenuInfo;
      this.usePoint = 0;
      this.checkedAgree1 = false;
      this.checkedAgree2 = false;
      this.checkedAgree3 = false;
      this.checkedAgree4 = false;
      this.isError = false;
    },
    async hideModal() {
      this.isError = false;
      this.$emit("hide");
    },
    async clickSubmit() {
      this.isError = false;
      if (!this.checkDigits()) {
        return;
      }
      if (!this.checkAgree()) {
        return;
      }
      const usageAmount = this.totalPrice - this.subsidyTotal;
      const reqParam = {
        cafeMenuNo: this.selectedCafeMenuInfo.cafeMenuNo,
        cafeMenuBranchNo: this.selectedCafeMenuInfo.cafeMenuBranchNo,
        usageAmount: usageAmount,
        applyPoint: this.usePointType === "Point" ? this.usePoint : 0,
        applyAmount: this.usePointType === "Cash" ? this.usePoint : 0,
        dayCount: this.stayDays,
        useDate: this.useDate,
        userCount: this.totalAdult + this.totalChildren
      }
      const cafeRes = await this.$repositories("order").checkCafeInfo(reqParam);
      if (cafeRes.data.errMsg) {
        this.errMessage = cafeRes.data.errMsg;
        this.isError = true;
        return;
      }
      this.$emit("apply", {
          cafeMenuNo: this.selectedCafeMenuInfo.cafeMenuNo,
          cafeMenuBranchNo: this.selectedCafeMenuInfo.cafeMenuBranchNo,
          cafeApplyAmount: cafeRes.data.fixedAmount,
          cafeApplyPoint: cafeRes.data.fixedPoint
        });
      this.$emit("hide");
    },
    showAgree1() {
      if (this.selectedCafeMenuInfo && this.selectedCafeMenuInfo.memberAccompany) {
        return true;
      }
      return false;
    },
    showAgree2() {
      if (this.selectedCafeMenuInfo && this.selectedCafeMenuInfo.targetUsers.restriction === 1) {
        return true;
      }
      return false;
    },
    showAgree3() {
      if (this.selectedCafeMenuInfo && this.selectedCafeMenuInfo.targetUsers.restriction === 2) {
        return true;
      }
      return false;
    },
    showAgree4() {
      if (this.selectedCafeMenuInfo && this.selectedCafeMenuInfo.targetUsers.restriction === 3) {
        return true;
      }
      return false;
    },
    disabledSubmit() {
      return false;
    },
    generatePointRateLabel(rounding) {
      if (!rounding) return '';

      switch (rounding) {
        case '01':
          return '切り捨て';
        case '02':
          return '切り上げ';
        case '03':
          return '四捨五入';
        default:
          return '';
      }
    },
    changeUsePointType() {
      this.validateUsePoint(this.usePoint, this.usePointType);
    },
    changeSpinner() {
      this.validateUsePoint(this.usePoint, this.usePointType);
    },
    validateUsePoint(newValue, type) {
      console.log(newValue);
    },
    clickStepDown() {
      if (Number(this.usePoint) <= 0) return;

      this.usePoint = Number(this.usePoint) - 1;
      this.validateUsePoint(this.usePoint, this.usePointType);
    },
    clickStepUp() {
      this.usePoint = Number(this.usePoint) + 1;
      this.validateUsePoint(this.usePoint, this.usePointType);
    },
    clickCancel() {
      this.$emit('close');
    },
    generateRateForPoint() {
      const result = this.usePoint * this.selectedCafeMenuInfo.pointRate;
      switch (this.selectedCafeMenuInfo.rounding) {
        case '01':
          return Math.floor(result);

        case '02':
          return Math.ceil(result);

        case '03':
          return Math.round(result);

        default:
          return result;
      }
    },
    checkDigits() {
      if (!Number(this.usePoint)) {
        this.isError = true;
        this.errMessage = "申請ポイントには数値を入力してください。"
        return false;
      }
      if (this.usePoint > 99999999) {
        this.isError = true;
        this.errMessage = "申請ポイントは8桁以下で入力してください。";
        return false;
      }
      return true;
    },
    checkAgree() {
      let allCheck = true;
      if (this.showAgree1() && !this.checkedAgree1) {
        allCheck = false;
      }
      if (this.showAgree2() && !this.checkedAgree2) {
        allCheck = false;
      }
      if (this.showAgree3() && !this.checkedAgree3) {
        allCheck = false;
      }
      if (this.showAgree4() && !this.checkedAgree4) {
        allCheck = false;
      }
      if (!allCheck) {
        this.isError = true;
        this.errMessage = "ご利用には同意が必要です。";
      }
      return allCheck;
    }
  },
  mounted() {
    this.setCafeData();
  },
  watch: {
    cafeInfo: {
      deep: true,
      immediate: true,
      handler() {
        this.setCafeData();
      }
    },
    subsidyTotal: {
      immediate: true,
      handler() {
        this.billAmount = this.totalPrice - this.subsidyTotal;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>